module.exports = __webpack_public_path__ + "static/media/analysis.2ec3162b.svg";